import React from "react";
import { useI18n } from "../utilities/i18n";

function FirstSlide({ onLoginClick }) {
  const { t } = useI18n();

  return (
    <div className="main-modern">
      <section className="hero-section">
        <div className="hero-background" />
        <div className="hero-content">
          <div className="hero-brand-row">
            <img src="/images/afl-logo.png" className="hero-logo" alt="AFL" />
            <div className="hero-brand-text">
              <span className="hero-brand-label">{t('heroBrand')}</span>
              <span className="hero-brand-afl">AFL</span>
            </div>
          </div>
          <h1 className="hero-title">{t('heroTitle')}</h1>
          <p className="hero-subtitle">
            {t('heroSubtitle')}
          </p>
          <div className="hero-actions">
            <button
              type="button"
              onClick={onLoginClick}
              className="action-button action-button-primary"
            >
              {t('login')}
            </button>
            <a
              href="https://vk.com/ingame_app"
              target="_blank"
              rel="noopener noreferrer"
              className="action-button action-button-secondary"
            >
              {t('community')}
            </a>
          </div>
        </div>
      </section>

      <div className="landing-content">
        <div className="features-section">
          <h2 className="section-title">{t('featuresTitle')}</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">{t('featureMatches')}</div>
              <h3>{t('featureMatchesTitle')}</h3>
              <p>{t('featureMatchesText')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">{t('featureApps')}</div>
              <h3>{t('featureAppsTitle')}</h3>
              <p>{t('featureAppsText')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">{t('featureStats')}</div>
              <h3>{t('featureStatsTitle')}</h3>
              <p>{t('featureStatsText')}</p>
            </div>
          </div>
        </div>

        <div className="cta-section">
          <h2 className="cta-title">{t('ctaTitle')}</h2>
          <p className="cta-subtitle">
            {t('ctaSubtitle')}
          </p>
          <button
            type="button"
            onClick={onLoginClick}
            className="action-button action-button-primary"
          >
            {t('loginAdmin')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FirstSlide;
